<template>
    <v-lightbox is-authenticated maxed footerless :show="loginShow">
        <template v-slot:trigger>
            <slot name="trigger">
                <!-- This will preload the image, avoiding content jumps when dialog opens -->
                <link rel="prefetch" href="/assets/images/hiska-1-new.webp" />
                <a
                    @click="show = true"
                    class="button button--large hidden md:flex"
                >
                    Prijava
                    <v-icon icon="account-circle"></v-icon>
                </a>
            </slot>
        </template>
        <template v-slot:head>
            <div class="text-heading-3-desktop">Vstopite v</div>
            <v-icon icon="n24" size="12" class="ml-2.5 max-h-[1.5rem]"></v-icon>
        </template>
        <template v-slot:content>
            <div class="flex flex-col items-center">
                <figure class="mb-8">
                    <img
                        class="mx-auto max-h-[175px] object-cover"
                        :src="'/assets/images/hiska-1-new.webp'"
                    />
                </figure>
                <form
                    method="POST"
                    :action="loginPostRoute"
                    class="flex w-full max-w-[368px] flex-col items-center"
                >
                    <input type="hidden" name="_token" :value="csrfToken" />
                    <div class="w-full max-w-[368px]">
                        <v-form-input
                            id="userEmail"
                            label="Elektronska pošta"
                            type="email"
                            :value="email"
                            v-model="email"
                            class="mb-4 w-full"
                            :inputClassesProp="[
                                loginError ? '!ring-salmon-base' : '',
                            ]"
                            name="email"
                            :error-message="
                                loginValidationErrors.email
                                    ? loginValidationErrors.email[0]
                                    : ''
                            "
                        ></v-form-input>
                        <v-form-input
                            id="userPassword"
                            label="Geslo"
                            type="password"
                            :value="password"
                            v-model="password"
                            class="mb-4 w-full"
                            :inputClassesProp="[
                                loginError ? '!ring-salmon-base' : '',
                            ]"
                            name="password"
                            :error-message="
                                loginValidationErrors.password
                                    ? loginValidationErrors.password[0]
                                    : ''
                            "
                        ></v-form-input>
                    </div>

                    <v-alert variant="error" v-if="loginError">
                        {{ loginError }}
                    </v-alert>

                    <div class="flex items-center">
                        <button type="submit" class="button button--form">
                            Prijavite se
                            <v-icon icon="arrow-right-inside-box"></v-icon>
                        </button>
                    </div>
                </form>
                <div class="mt-4 w-full max-w-[240px]" v-if="facebookLoginRoute">
                    <a :href="facebookLoginRoute" class="button button--form button--facebook">
                        <v-icon icon="facebook"></v-icon>
                        <label class="ml-0 text-center">Nadaljujte z Facebookom</label>
                    </a>
                </div>
                <div class="mt-4 w-full max-w-[240px]" v-if="googleLoginRoute">
                    <a :href="googleLoginRoute" class="button button--form button--google">
                        <v-icon icon="google"></v-icon>
                        <label class="ml-0 text-center">Nadaljujte z Googlom</label>
                    </a>
                </div>
                <div class="mt-4 w-full max-w-[240px]">
                    <a
                        :href="forgotPasswordRoute"
                        class="button button--form button--white"
                    >
                        Ste pozabili geslo
                        <v-icon icon="missing-brain"></v-icon>
                    </a>
                </div>
                <div class="justficy-center flex w-full items-center pb-8 pt-8">
                    <div class="h-[1px] w-full bg-gray"></div>
                    <div class="pl-6 pr-6 text-small-text-medium text-black-40">
                        ali
                    </div>
                    <div class="h-[1px] w-full bg-gray"></div>
                </div>
                <div class="w-full max-w-[240px]">
                    <a
                        href="/registracija"
                        class="button button--form button--dark"
                    >
                        Registriracija z email
                        <v-icon icon="user-plus"></v-icon>
                    </a>
                </div>
            </div>
        </template>
    </v-lightbox>
</template>

<script>
export default {
    props: {
        loginShow: {
            type: Boolean,
            default: false,
        },
        loginError: {
            type: String,
        },
        loginPostRoute: {
            type: String,
            required: true,
        },
        registerRoute: {
            type: String,
            required: true,
        },
        forgotPasswordRoute: {
            type: String,
            required: true,
        },
        facebookLoginRoute: {
            type: String,
            required: true,
        },
        googleLoginRoute: {
            type: String,
            required: true,
        },
        csrfToken: {
            type: String,
            required: true,
        },
        loginValidationErrors: {
            type: Object,
            required: false,
            default: {},
        },
    },
    data() {
        return {
            email: "",
            password: "",
        };
    },
    mounted() {},
};
</script>
